import React from 'react';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
import Rotation from './Rotation';

function RotationsSearch() {
  return (
    <SearchMenu>
      <FilterConsumer>{({ agencies }) => <Rotation filter={agencies} />}</FilterConsumer>
    </SearchMenu>
  );
}

export default RotationsSearch;
